<template>
    <Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
        <!-- Start Slider area -->
        <div class="slider-area slider-style-2 variation-2 height-450 bg_image"
             :style="{'background-image': `url(${require(`@/assets/images/bwt/banner-index.jpg`)})`}">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-xl-6">
                        <div class="inner text-start">
                            <h1 class="title display-one" data-aos="fade-up" data-aos-delay="100">
															成为业界领先的数字化转型合作商
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Separator/>

        <!-- Start Elements Area -->
        <div class="rwt-advance-tab-area rn-section-gap">
            <div class="container">
                <h2 class="w-600 title text-center">AI、数据、云产品与服务</h2>
							  <h4 class="text-center">加速企业的数字化转型</h4>
							<div class="swiper-container">
								<div class="swiper-wrapper">
									<div class="swiper-slide" v-for="(img,index) in bannerList" :key="index">
										<img :src="img.imgUrl" />
										<div class="con-box">
											<div class="title">{{img.title}}</div>
											<div class="text">{{img.text}}</div>
										</div>
									</div>
								</div>

								<div class="swiper-button-next"></div>
								<div class="swiper-button-prev"></div>
							</div>
            </div>
        </div>
        <!-- End Elements Area -->

			<Separator/>

			<div class="rwt-advance-tab-area rn-section-gap">
				<div class="container">
					<h2 class="w-600 title text-center">高可用的行业解决方案</h2>
					<h4 class="text-center">助力产业创新</h4>
					<div class="home-programme-list">
						<ul class="clearfix">
							<li v-for="(card,index) in cardList" :key="index">
								<div class="block-box js-m">
									<div class="pic">
										<img :src="card.imgUrl" />
									</div>
									<div class="cont-inner">
										<div class="icon">
											<img :src="card.iconUrl" />
										</div>
										<div class="cont-box">
											<div class="title">{{card.title}}</div>
											<div class="text">{{card.text}}</div>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
    </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import Separator from '../../components/elements/separator/Separator'
		import Swiper from 'swiper'

		import "swiper/css/swiper.css";

    export default {
        name: 'Index',
        components: {Separator, Layout},
        data() {
            return {
							bannerList: [
								{
									imgUrl: require(`@/assets/images/bwt/index-s1.jpeg`),
									title: 'CherGPT',
									text: '借助企业智慧管理体系、算法培育与调控，激发企业AI内生应用场景的潜能'
								},
								{
									imgUrl: require(`@/assets/images/bwt/index-s2.png`),
									title: '云服务管理',
									text: '为客户的既有IT架构与云原生生态系统提供涵盖咨询、迁移、运维、部署的专业解决方案及托管服务'
								},
								{
									imgUrl: require(`@/assets/images/bwt/index-s3.png`),
									title: '产研一体',
									text: '自研提供一体化工业互联网解决方案'
								},
								{
									imgUrl: require(`@/assets/images/bwt/index-s4.png`),
									title: '安全服务',
									text: '结合安全行业服务经验，提供企业云安全、终端安全、邮件安全解决方案'
								}
							],
							cardList: [
								{
									imgUrl: require(`@/assets/images/bwt/index-card-1.jpg`),
									iconUrl: require(`@/assets/images/bwt/index-card-icon-1.png`),
									title: '金融',
									text: '高安全高可用的算力基础设施与数据安全管控'
								},
								{
									imgUrl: require(`@/assets/images/bwt/index-card-1.jpg`),
									iconUrl: require(`@/assets/images/bwt/index-card-icon-2.png`),
									title: '运营商',
									text: '提供安全稳固的算力网络基座'
								},
								{
									imgUrl: require(`@/assets/images/bwt/index-card-3.jpg`),
									iconUrl: require(`@/assets/images/bwt/index-card-icon-3.png`),
									title: '制造',
									text: '研制一体化工业互联网、供应链优化管理'
								}
							]
            }
        },
			mounted() {
				new Swiper(".swiper-container", {
					loop: true,
					mousewheel: true,
					keyboard: true,
					slidesPerView: 3,
					spaceBetween: 30,
					centeredSlides: true,

					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
				});
			}
    }
</script>
<style lang="scss" scoped>
.swiper-container {
	margin-top: 60px;
	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: #fff;

		/* Center slide text vertically */
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
		transition: 300ms;
		transform: scale(0.8);
		position: relative;
		border-radius: 8px;

		img {
			border-radius: 8px;
		}

		.con-box {
			text-align: left;
			width: 100%;
			position: absolute;
			left: 0;
			bottom: 0;
			padding: 12px 16px;
			border-radius: 0 0 8px 8px;
			color: #fff;
			background: linear-gradient(to right, #D3001D, rgba(211, 0, 29, 0.1));
			.title {
				font-size: 20px;
			}
			.text {
				font-size: 14px;
			}
		}
		&:nth-child(2n) .con-box {
			background: linear-gradient(to right, #2350a0, rgba(35,80,160,0.1));
		}
	}
	.swiper-slide-active,.swiper-slide-duplicate-active{
		transform: scale(1);
	}
	.swiper-button-next {
		right: 0 !important;
	}
	.swiper-button-prev {
		left: 0 !important;
	}
}
.home-programme-list {
	margin-top: 60px;
	.clearfix {
		display: block;
		list-style: none outside none;
		padding: 0;
		margin: 0;
	}
	li {
		float: left;
		width: 33.333%;
		.block-box {
			position: relative;
			.pic {
				position: relative;
				overflow: hidden;
				&:before {
					content: '';
					width: 100%;
					height: 100%;
					background-color: rgba(000, 000, 000, 0.5);
					position: absolute;
					top: 0;
					left: 0;
					z-index: 3;
					transition: all 0.5s ease;
					-webkit-transition: all 0.5s ease;
					-moz-transition: all 0.5s ease;
				}
				img {
					transition: all 0.5s ease;
				}
			}
			&:hover .pic {
				&:before {
					display: none;
				}
				img {
					transform: scale(1.1);
				}
			}
			.cont-inner {
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				bottom: 0;
				z-index: 5;
				.icon {
					width: 48px;
					margin: 64px auto 0;
					img {
						display: block;
						width: 100%;
					}
				}
				.cont-box {
					color: #fff;
					text-align: center;
					margin-top: 32px;
					.title {
						font-size: 24px;
						font-weight: bold;
					}
					.text {
						margin-top: 8px;
						font-size: 16px;
					}
				}
			}
		}
	}
}
.js-m {
	transform: translate(0, 30px);
	transition: all 0.8s cubic-bezier(0.79, -0.27, 0.21, 0.82);
}
</style>
